export default "__VITE_ASSET__DRHNQSMn__"